import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await login(username, password);
      navigate("/"); // ✅ THIS IS THE MISSING PIECE
    } catch {
      setError("Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-xl shadow-sm w-full max-w-sm"
      >
        <h1 className="text-xl font-semibold mb-4">Doctor Login</h1>

        {error && (
          <div className="text-red-600 text-sm mb-3">{error}</div>
        )}

        <input
          className="w-full h-11 border rounded-lg px-3 mb-3"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />

        <input
          type="password"
          className="w-full h-11 border rounded-lg px-3 mb-4"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button
          type="submit"
          className="w-full h-11 bg-blue-600 text-white rounded-lg"
        >
          Login
        </button>
      </form>
    </div>
  );
}

export default Login;
